import React from 'react';
import { ChildrenOwnerProps } from '../Base';

export default function ColoredContainer(props: ChildrenOwnerProps) {
  return <div className="w-full rounded-md bg-mint-medical-green-lighter p-2">{props.children}</div>;
}
